// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__12Jch","list":"BalanceDue_list__3Fz09","listRow":"BalanceDue_listRow__3n4u0","total":"BalanceDue_total__16K2j"};